<!-- 添加设备列表 -->
<template>
    <div class="container containerBox">
        <el-alert
            style="margin-bottom:10px;"
            :title="groupInfo.groupname"
            type="success"
            :description="'备注：' + groupInfo.description">
        </el-alert>
        <div>
            <el-button type="primary" size="medium" icon="el-icon-plus" @click="handleAddMeter">添加设备</el-button>
            <el-button type="danger" size="medium" icon="el-icon-delete" @click="handleDeleteMeter">删除设备</el-button>
        </div>
        <!-- 设备列表 -->
        <el-table
            ref="multipleTable"
            :data="deviceListTable"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="terminal_serial" label="序列号" sortable>
            </el-table-column>
            <el-table-column prop="device_model" label="表计型号">
            </el-table-column>
            <el-table-column prop="dev_type" label="表计类型" :formatter="fmtDevType" sortable>
            </el-table-column>
            <el-table-column prop="collector_name" label="集控器名称">
            </el-table-column>
            <el-table-column prop="house_name" label="安装位置">
            </el-table-column>
            <el-table-column label="通讯状态" sortable>
                <template slot-scope="scope">
                    <el-tag :type="scope.row.online_status === 1 ? 'success': 'danger'">{{fmtStatus(scope.row)}}</el-tag>
                </template>
            </el-table-column>
        </el-table>

        <!-- 添加设备弹框 -->
        <cmp-add-dialog  v-if="modalVisible" :defaultList="defaultList" :devType="devType" :modalShow.sync="modalVisible"></cmp-add-dialog>
    </div>
</template>

<script>
import Service from '@/api/Service'
import { funFmtDevType, funFmtOnlineStatus } from '@/utils/utils'
import CmpAddDialog from './CmpAddEquipmentDialog'

export default {
    name: "equipmentlist",
    inject: ["reload"],
    data() {
        return {
            groupInfo: {},
            deviceListTable: [], // 设备列表
            multipleSelection: [],  //选中设备项
            modalVisible: false,
            devType: 0,
        };
    },
    computed: {
        defaultList() {
            let arr = [];
            this.deviceListTable.map(v=> {
                arr.push({ oid: v.oid})
            });
            return arr
        }
    },
    created() {
        this.getMeterGroupInfo(this.$route.params.groupId);
    },
    components: {
        CmpAddDialog
    },
    methods: {
        // 获取设备信息
        async getMeterGroupInfo(oid) {
            let data = await Service.getMeterGroupInfo({OID: oid});
            if(data) {
                this.groupInfo = data[0];
                this.deviceListTable = data[0].devices || [];
				
				for(var i = 0;i < this.deviceListTable.length;i++){
					if(this.deviceListTable[i].moduleid_list){
						let arr = JSON.parse(this.deviceListTable[i].moduleid_list);
						this.deviceListTable[i].house_name=arr[0].modulename + arr[1].modulename + this.deviceListTable[i].house_name
					}
					
				}
                this.devType = data[0].dev_type
            }
        },

        // 添加设备
        handleAddMeter() {
            this.modalVisible = true;
        },

        // 选择设备
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        // 删除设备
        async handleDeleteMeter() {
            if(this.multipleSelection.length<=0) {
                this.$notify({
                    title: '警告',
                    message: '请选择要删除的设备',
                    type: 'warning'
                });
                return
            }
            let choseIds, devices;
            // 已选择设备Id
            choseIds = this.multipleSelection.map(v=>{
                return v.oid
            })

            // 剩下所有设备ID
            devices = this.defaultList.filter(v=>{
                return !choseIds.includes(v.oid);
            })
            
            let OID = this.$route.params.groupId;
            let data = await Service.editDevGroupMeter({ devices, OID });
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.reload();
            }
        },

        // 格式通讯状态
        fmtStatus(row) {
            return funFmtOnlineStatus(row.online_status)
        },
        // 格式化表计类型
        fmtDevType(row) {
            return funFmtDevType(row.dev_type);
        },
    },
};
</script>
<style lang='css' scoped>
    .foot{
        margin-top:20px;
        text-align:right;
    }
</style>